var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mainPage",class:_vm.breakpoints,attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }